import type { SxProps, Theme } from '@mui/material';

export const card: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.background.paper,
  border: (theme) => `1px solid ${theme.palette.divider}`,
  borderRadius: 2,
  height: 'fit-content',
  maxWidth: '600px',
};

export const cardContent: SxProps<Theme> = {
  p: 3,
};

export const title: SxProps<Theme> = {
  mb: 1,
  fontWeight: 600,
};

export const description: SxProps<Theme> = {
  mb: 3,
};

export const fieldContainer: SxProps<Theme> = {
  mb: 3,
};

export const fieldLabel: SxProps<Theme> = {
  mb: 1,
  color: 'text.secondary',
};

export const textField: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: (theme) =>
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.02)',
  },
};

export const submitButton: SxProps<Theme> = {
  mb: 3,
  textTransform: 'none',
  fontWeight: 500,
  '&:disabled': {
    backgroundColor: (theme) => theme.palette.action.disabled,
    color: (theme) => theme.palette.action.disabled,
  },
};

export const infoAlert: SxProps<Theme> = {
  backgroundColor: (theme) =>
    theme.palette.mode === 'dark' ? 'rgba(0, 150, 136, 0.1)' : 'rgba(0, 150, 136, 0.1)',
  color: (theme) => (theme.palette.mode === 'dark' ? '#4db6ac' : '#00695c'),
  border: (theme) =>
    `1px solid ${
      theme.palette.mode === 'dark' ? 'rgba(0, 150, 136, 0.3)' : 'rgba(0, 150, 136, 0.3)'
    }`,
  '& .MuiAlert-icon': {
    color: (theme) => (theme.palette.mode === 'dark' ? '#4db6ac' : '#00695c'),
  },
};
